import type { AnyRouter } from "@tanstack/react-router";
import { useState } from "react";

import { DevToolsMenu } from "./DevToolsMenu";
import { DevToolsTrigger } from "./DevToolsTrigger";
import { Console } from "./tools/Console/Console";
import { TanstackQueryDevtools } from "./tools/TanstackQueryDevtools";
import { TanstackRouterDevtools } from "./tools/TanstackRouterDevtools";
import { usePurchaseBlock } from "./tools/usePurchaseBlock";

export type ActivePanel = "rq" | "router" | "console" | null;

interface DevToolsHubProps {
  router: AnyRouter;
}

export function DevToolsHub({ router }: DevToolsHubProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [activePanel, setActivePanel] = useState<ActivePanel>(null);

  const purchaseBlock = usePurchaseBlock();

  const togglePanel = (panel: NonNullable<ActivePanel>) => {
    setActivePanel((prev) => (prev === panel ? null : panel));
    setAnchorEl(null);
  };

  return (
    <div dir="ltr">
      <div>
        <Console isOpen={activePanel === "console"} />
        <TanstackQueryDevtools isOpen={activePanel === "rq"} />
        <TanstackRouterDevtools
          router={router}
          isOpen={activePanel === "router"}
        />
      </div>

      <DevToolsTrigger
        isOpen={Boolean(anchorEl) || Boolean(activePanel)}
        onClick={(e) => {
          if (activePanel) setActivePanel(null);
          setAnchorEl((prev) => (prev ? null : e.currentTarget));
        }}
        purchaseBlock={purchaseBlock}
      />

      <DevToolsMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        activePanel={activePanel}
        onTogglePanel={togglePanel}
        purchaseBlock={purchaseBlock}
      />
    </div>
  );
}
